import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M12 18c3.3137 0 6-2.6863 6-6s-2.6863-6-6-6-6 2.6863-6 6 2.6863 6 6 6m0 2c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 17c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1m-5-5c0 .5523-.4477 1-1 1H3c-.5523 0-1-.4477-1-1s.4477-1 1-1h3c.5523 0 1 .4477 1 1m15 0c0 .5523-.4477 1-1 1h-3c-.5523 0-1-.4477-1-1s.4477-1 1-1h3c.5523 0 1 .4477 1 1M12 2c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1m0 12c-1.1046 0-2-.8954-2-2s.8954-2 2-2 2 .8954 2 2-.8954 2-2 2",
        clipRule: "evenodd"
    }, "1")
], "AudienceContextual", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
